import { render } from "./UnitInfo.vue?vue&type=template&id=33b2ec0c"
import script from "./UnitInfo.vue?vue&type=script&lang=js"
export * from "./UnitInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__